import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../utils/api";

export default function ResetPassword() {

    const { token } = useParams();
    const navigate = useNavigate();

    const [password, setPassword] = useState("");
    const [msg, setMsg] = useState("");

    const submit = async (e) => {
        e.preventDefault();

        try {

            await api.post("/auth/reset-password", {
                token,
                password
            });

            setMsg("Password Updated");

            setTimeout(() => navigate("/login"), 1500);

        } catch (err) {
            setMsg("Invalid or Expired Link");
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center">
            <form onSubmit={submit} className="space-y-4 w-80">
                <h2 className="text-2xl font-serif">Reset Password</h2>

                <input
                    type="password"
                    placeholder="New Password"
                    className="w-full border p-2"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    required
                />

                <button className="w-full bg-black text-white py-2">
                    Update Password
                </button>

                {msg && <p>{msg}</p>}
            </form>
        </div>
    );
}